import { render, staticRenderFns } from "./limited-access.vue?vue&type=template&id=312282d6&scoped=true"
import script from "./limited-access.vue?vue&type=script&lang=js"
export * from "./limited-access.vue?vue&type=script&lang=js"
import style0 from "./limited-access.vue?vue&type=style&index=0&id=312282d6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "312282d6",
  null
  
)

export default component.exports